<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-bike-ride">
<h1>The Bike Ride</h1>
<p style="text-indent: 00em;">A new day has dawned, bright and clear</p>
<p style="text-indent: 00em;">There’s an autumn crispness in the air</p>
<p style="text-indent: 00em;">It’s off we go now to the cycle track</p>
<p style="text-indent: 00em;">Me in the front and Ken at the back</p>
<p style="text-indent: 00em;">He lets me go ahead and set the pace</p>
<p style="text-indent: 00em;">I don’t mind really as he can’t see the grimace on my face</p><br/>
<p style="text-indent: 00em;">We wind our way through the shady glades</p>
<p style="text-indent: 00em;">Over rough cattle stops that dislodge our shades</p>
<p style="text-indent: 00em;">There’s no wind today, just a gentle breeze</p>
<p style="text-indent: 00em;">But some of the hills get you in the knees</p>
<p style="text-indent: 00em;">And the bum that sure gets sore a bit</p>
<p style="text-indent: 00em;">So, we’re very tentative when next we sit</p><br/>
<p style="text-indent: 00em;">Nearly 22 kilometres we’ve done today</p>
<p style="text-indent: 00em;">And when we get home that’s where we’ll stay</p>
<p style="text-indent: 00em;">We’re not as young as we used to be</p>
<p style="text-indent: 00em;">A long ride like this takes it out of him and me</p>
<p style="text-indent: 00em;">Maybe a nap will help us recover</p>
<p style="text-indent: 00em;">There will no doubt be some new aches, we will discover</p>
<p style="text-indent: 00em;">We’ll do it all the next day again</p>
<p style="text-indent: 00em;">You would think that we really enjoyed the pain</p>
<p style="text-indent: 00em;">Hopefully the kilos will drop away,</p>
<p style="text-indent: 00em;">As we go out for our ride every other day.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch013.vue?0f5b3b21